/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
'use strict';
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
$('body').removeClass('no-js').addClass('js-enabled');

//  Declare Flexbox useable
(function checkIE() {
  var webAgent = window.navigator.userAgent;
  var Idx = webAgent.indexOf("MSIE");

  // If not IE, replace no-flexbox with flexbox
  if (Idx) {
    $('body').removeClass('no-flexbox').addClass('flexbox');
  }
})();

/*
--------------------
Modules
--------------------
*/
